import { Component, OnInit } from '@angular/core';
import * as $ from '../../assets/js/jquery-3.2.1.min.js';


@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    
  }

}
